class HomepageBannerCarouselController extends window.MediaQueryController {
  static values = {
    autoplay: Boolean,
    autoplayDelay: Number,
    pauseOnMouseEnter: Boolean,
  };

  connect() {
    this.swiper = this.#initSwiper();

    this.onWindowResize((activeBreakpoint) => {
      if (this.autoplayValue) {
        if (activeBreakpoint === "small") {
          this.swiper.autoplay.stop();
        } else {
          this.swiper.autoplay.start();
        }
      }
    });
  }

  #initSwiper() {
    return new Swiper(".homepage-banner-carousel-swiper", {
      slidesPerView: 1,
      pagination: {
        el: ".homepage-banner-carousel-pagination",
        bulletActiveClass: "swiper-pagination-bullet-active tw-bg-white",
        bulletClass:
          "swiper-pagination-bullet tw-opacity-100 tw-border tw-border-white tw-bg-transparent",
        clickable: true,
      },
      loop: true,
      ...this.#autoplay,
    });
  }

  get #autoplay() {
    if (!this.autoplayValue) {
      return null;
    }

    return {
      autoplay: {
        delay: this.autoplayDelayValue,
        pauseOnMouseEnter: this.pauseOnMouseEnterValue,
      },
    };
  }
}

Stimulus.register("homepage-banner-carousel", HomepageBannerCarouselController);
